import { useCallback, useState } from "react";

import { gql } from "@examspark/api";
import { assertNativeError, isAppSyncError } from "@examspark/common";

import { useAppContext } from "../providers/AppContext";

export const useJoinWorkspace = () => {
  const [state] = useAppContext();
  const [workspaceId, setWorkspaceId] = useState("");
  const [code, setCode] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = useCallback(async () => {
    if (!state.user?.email) {
      console.error("User email not found");
      return;
    }

    try {
      setIsSubmitting(true);
      const registrationStatus = (
        await gql.operations.registration.determineRegistrationStatus({
          workspaceId,
          email: state.user.email,
          code,
        })
      ).data?.determineRegistrationStatus;

      if (!registrationStatus?.jwt) {
        throw new Error("Invalid registration status");
      }

      // console.log(registrationStatus);
      const registerAppUserResult =
        await gql.operations.registration.registerAppUser({
          jwt: registrationStatus.jwt,
        });

      if (registerAppUserResult.data?.registerAppUser.status !== "success") {
        throw new Error("Failed to register app user");
      }

      return registerAppUserResult.data?.registerAppUser;
    } catch (error) {
      if (isAppSyncError(error)) {
        const firstError = error.errors[0];
        switch (firstError.errorType) {
          case "invalid-code":
            throw new Error(
              "Invalid registration code. Please double-check and try again.",
            );
          case "invalid-email":
            throw new Error(
              "Invalid email. Please double-check and try again.",
            );
          default:
            throw new Error(firstError.message);
        }
      }

      assertNativeError(error);
      throw new Error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  }, [code, state.user?.email, workspaceId]);

  return {
    code,
    setCode,
    workspaceId,
    setWorkspaceId,
    handleSubmit,
    isSubmitting,
    isValid: !!code && !!workspaceId,
  };
};
